import React from "react";
import { classNames } from "maven-lib/dist/utils/misc";

interface HbDividerProps {
  color?: "TRANSPARENT" | "GRAY";
  space: 1 | 2 | 3 | 4 | 5;
}

export function HbDivider(props: HbDividerProps) {
  const { space, color } = props;

  return (
    <>
      <div className={classNames("hb-divider", `--space-${space}`, `--color-${String(color || "default").toLowerCase()}`)}>
        <hr />
      </div>
    </>
  );
}

HbDivider.defaultProps = {
  color: "TRANSPARENT",
  space: 1,
};
